module.exports = __webpack_public_path__ + "img/206590fe22ac2a1d926a16664850ca8.dbdc61e7.jpg";